import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Teachers from './pages/Teachers';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import FreeTrial from './pages/FreeTrial';
import StudyPlansFees from './pages/StudyPlansFees';
import PaymentOptions from './pages/PaymentOptions';
import BecomeTeacher from './pages/BecomeTeacher';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:slug" element={<CourseDetail />} />
          <Route path="/our-teachers" element={<Teachers />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/free-trial" element={<FreeTrial />} />
          <Route path="/study-plans-fees" element={<StudyPlansFees />} />
          <Route path="/payment-options" element={<PaymentOptions />} />
          <Route path="/become-a-teacher" element={<BecomeTeacher />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
